module.exports = __webpack_public_path__ + "img/paragraphEle.f78bee17.svg";